import type React from 'react';

import { Loader } from '@change-corgi/design-system-legacy/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system-legacy/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AIDescriptionWrapper } from './components/AIDescriptionWrapper';

async function loadAIDescriptionStep(): Promise<typeof AIDescriptionWrapper> {
	return (
		await import(
			/* webpackChunkName: "pages/start-a-petition-steps-ai-description" */ './components/AIDescriptionWrapper'
		)
	).AIDescriptionWrapper;
}

export const AIDescriptionLoader: React.FC = () => {
	return (
		<LazyComponent
			loadComponent={loadAIDescriptionStep}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
};

export const preloadAIDescriptionStep = loadAIDescriptionStep;
